export enum TableColumnFields {
	INDEX = "INDEX",
	NAME = "NAME",
	AGE = "AGE",
	LEVEL = "LEVEL",
	GENDER = "GENDER",
	PRIMARY_COACH_NAME = "PRIMARY_COACH_NAME",
	PRIMARY_COACH_GENDER = "PRIMARY_COACH_GENDER",
	PRIMARY_COACH_EMAIL = "PRIMARY_COACH_EMAIL",
	SECONDARY_COACH_NAME = "SECONDARY_COACH_NAME",
	SECONDARY_COACH_GENDER = "SECONDARY_COACH_GENDER",
	SECONDARY_COACH_EMAIL = "SECONDARY_COACH_EMAIL",
	MANAGER_NAME = "MANAGER_NAME",
	MANAGER_EMAIL = "MANAGER_EMAIL"
}
